import React from "react";

/**
 * Appointment stepper with stable keys (no array index as React key).
 */
export default function AppointmentStepper({ steps, current }) {
  return (
    <div
      className="flex items-center gap-2 md:gap-4 mb-10 overflow-x-auto"
      data-testid="appointment-stepper"
    >
      {steps.map((step, i) => (
        <div key={step.id} className="flex items-center gap-2 md:gap-4 shrink-0">
          <span
            className={`w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-medium transition-colors duration-300 ${
              i <= current ? "bg-arven-gold text-arven-noir" : "bg-white/10 text-arven-offwhite/55"
            }`}
          >
            {i + 1}
          </span>
          <span
            className={`text-[11px] md:text-[12px] tracking-[0.18em] uppercase whitespace-nowrap ${
              i === current ? "text-arven-offwhite" : "text-arven-offwhite/45"
            }`}
          >
            {step.label}
          </span>
          {i < steps.length - 1 && (
            <span className="hidden md:inline-block w-10 h-px bg-white/15" />
          )}
        </div>
      ))}
    </div>
  );
}
